
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M508.875 248.458l-74.667-74.667c-3.042-3.052-7.646-3.948-11.625-2.313a10.672 10.672 0 00-6.583 9.854v32a10.66 10.66 0 003.125 7.542l13.792 13.792H277.333V79.083l13.792 13.792c2 2 4.708 3.125 7.542 3.125h32c4.313 0 8.208-2.594 9.854-6.583a10.692 10.692 0 00-2.313-11.625L263.542 3.125c-4.167-4.167-10.917-4.167-15.083 0l-74.667 74.667a10.693 10.693 0 00-2.313 11.625A10.655 10.655 0 00181.333 96h32a10.66 10.66 0 007.542-3.125l13.792-13.792v155.583H79.083l13.792-13.792c2-2 3.125-4.708 3.125-7.542v-32a10.67 10.67 0 00-6.583-9.854 10.643 10.643 0 00-11.625 2.313L3.125 248.458c-4.167 4.167-4.167 10.917 0 15.083l74.667 74.667a10.664 10.664 0 007.542 3.125c1.375 0 2.771-.26 4.083-.813A10.672 10.672 0 0096 330.666v-32a10.66 10.66 0 00-3.125-7.542l-13.792-13.792h155.583v155.583l-13.792-13.792c-2-2-4.708-3.125-7.542-3.125h-32a10.655 10.655 0 00-9.854 6.583 10.692 10.692 0 002.313 11.625l74.667 74.667a10.634 10.634 0 007.542 3.125c2.729 0 5.458-1.042 7.542-3.125l74.667-74.667a10.693 10.693 0 002.313-11.625 10.655 10.655 0 00-9.854-6.583h-32a10.66 10.66 0 00-7.542 3.125l-13.792 13.792V277.333h155.583l-13.792 13.792c-2 2-3.125 4.708-3.125 7.542v32a10.67 10.67 0 006.583 9.854c1.313.552 2.708.813 4.083.813 2.771 0 5.5-1.083 7.542-3.125l74.667-74.667c4.167-4.167 4.167-10.917 0-15.084z"}})])
          )
        }
      }
    